import React from "react";
import { Edit, SimpleForm, SelectInput } from "react-admin";

export const UserQueryEdit = (props) => {
  const options = [
    {
      name: "Yes",
      value: true,
    },
    {
      name: "No",
      value: false,
    },
  ];

  return (
    <Edit {...props}>
      <SimpleForm>
        <SelectInput
          title="Is Resolved ?"
          source="resolved"
          choices={options}
          optionText="name"
          optionValue="value"
        />
      </SimpleForm>
    </Edit>
  );
};
